<template>
  <div class="letter py-3 d-flex flex-column gap-3">

    <slot v-if="!hideFrom" name="from">
      <div v-if="onlyShowSealInFrom" class="d-flex flex-column align-items-center">
        <img v-if="citySealUrl" :src="citySealUrl" class="seal-logo lg" />
      </div>
      <div v-else class="d-flex flex-row align-items-start">
        <div class="w-25">
          <img v-if="citySealUrl" :src="citySealUrl" class="seal-logo" />
        </div>
        <div class="w-50 text-center fw-bold">
          <div>
            {{ city.formalName }}
          </div>
          <div>
            {{ city.officeTitle }}
          </div>
          <div>
            {{ city.townHallAddress }}
          </div>
          <div>
            {{ city.name }}, {{ city.state }} {{ city.zipCode }}
          </div>
        </div>
        <div class="w-25">&nbsp;</div>
      </div>
    </slot>

    <slot v-if="!hideTo" name="to">
      <div class="d-flex flex-row align-items-start">
        <div v-if="!hideIndents" class="me-2">To:</div>
        <div>
          <div v-for="owner in model.ownersFormatted" :key="owner">
            {{ owner }}
          </div>
          <div v-for="addressLine in model.ownerAddressLines" :key="addressLine">
            {{ addressLine }}
          </div>
        </div>
      </div>
    </slot>

    <slot v-if="!hideDate" name="date">
      <div :class="`text-${dateAlignment}`">
        {{ model.dateFormatted }}
      </div>
    </slot>

    <slot name="subject">
      <div class="d-flex flex-row align-items-start">
        <div v-if="!hideIndents" class="me-2">Re:</div>
        <div>
          <div>
            {{ city.violationLetterTitle }}
          </div>
          <div v-if="city.violationLetterSubtitle">
            {{ city.violationLetterSubtitle }}
          </div>
        </div>
      </div>
    </slot>

    <div class="row d-flex flex-row align-items-stretch">
      <div class="col col-12 d-flex flex-column">

        <!-- Main content -->
        <slot />

        <!-- Signature -->
        <div class="letter-signature">
          <br v-for="n in signatureMarginLineCount" :key="n" />
          <slot name="signature">
            <div>
              Sincerely,
            </div>
            <br/>
            <br/>
            <br/>
            <slot name="signature-image">
              <div>&nbsp;</div>
            </slot>
            <div>
              {{ city.contactName }}
            </div>
            <div>
              {{ city.contactTitle }}
            </div>
            <div v-if="city.contactPhone">
              {{ formatPhone(city.contactPhone) }}
            </div>
            <div v-if="city.contactEmail">
              {{ city.contactEmail }}
            </div>
          </slot>

        </div>
      </div>

    </div>

  </div>

  <div v-if="!hideFooter" class="print-footer text-center mb-2">
    <slot name="footer">
      {{ city.officeTitle }}, {{ city.townHallAddress }}
      <br/>
      {{ city.admin?.url }} | Phone: {{ city.phoneNumber }} | Fax: {{ city.faxNumber }}
    </slot>
  </div>
</template>

<script>
import {LetterContext} from "@/models/letterContext";

export default {
  props: {
    model: LetterContext,
    onlyShowSealInFrom: Boolean,
    hideFrom: Boolean,
    hideTo: Boolean,
    hideDate: Boolean,
    hideFooter: Boolean,
    hideIndents: Boolean,
    dateAlignment: {
      type: String,
      default: () => 'center'
    },
    signatureMarginLineCount: {
      type: Number,
      default: 3
    }
  },
  emits: ['ready'],
  mounted() {
    setTimeout(() => this.$emit('ready'), 500);
  },
  computed: {
    city() {
      return this.model.city;
    },
    citySealUrl() {
      return this.city.townSealUrl;
    }
  }
}
</script>

<style>
.letter {
  line-height: 16px;
  min-height: 866px;
}
@media print {
  .letter {
    padding-bottom: 2rem;
    margin-bottom: 2rem;
    font-size: 12px;
    line-height: 16px;
    min-height: auto;
  }
  .letter-signature {
    page-break-inside: avoid;
  }
  .print-footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 2rem;
    text-align: center;
    font-size: 10px;
    background-color: var(--bs-white);
  }
}
</style>
